import styled from 'styled-components';
import { Box } from '@rsos/base-components';

const GAP_SIZE = 16;

const CONTENT_PADDING_SIZE = 16;

export const OverviewTabContent = styled(Box).attrs({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gridGap: `${GAP_SIZE}px`,
})``;

interface StyledContentProps {
  noBorder?: boolean;
}

const StyledContent = styled(Box).attrs(({ noBorder }: StyledContentProps) => ({
  border: noBorder ? 'none' : '1px solid',
  borderColor: noBorder ? undefined : 'heavyLineOutline',
  borderRadius: noBorder ? undefined : '5px',
}))<StyledContentProps>``;

interface FullWidthContentProps extends StyledContentProps {
  noPadding?: boolean;
}

export const FullWidthContent = styled(StyledContent).attrs(
  ({ noPadding }: FullWidthContentProps) => ({
    flexShrink: 0,
    width: '100%',
    padding: noPadding ? '0' : CONTENT_PADDING_SIZE,
  }),
)<FullWidthContentProps>``;

export const HalfWidthContent = styled(StyledContent).attrs({
  flex: `0 0 calc(50% - ${GAP_SIZE / 2}px)`,
  width: '50%',
  padding: '16px',
})``;

export const CardOverlay = styled(Box).attrs({
  width: '100%',
  height: '100%',
  padding: '16px',
  borderRadius: '5px',
  cursor: 'pointer',
})`
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const RcsNotification = styled(Box).attrs({
  horizontal: true,
  color: 'background',
  borderRadius: '5px',
  align: 'center',
  padding: '12px 12px',
})`
  gap: 10px;
  width: 100%;
`;

export const TextTo911Notification = styled(Box).attrs({
  horizontal: true,
  color: 'background',
  borderRadius: '5px',
  align: 'center',
  padding: '12px 12px',
})`
  gap: 10px;
  width: 100%;
`;
